import { DivisionCategoryRow, DivisionCategoryType } from '../../../services/api.types'

const RESERVED_COLUMNS = new Set(['email', 'first_name', 'last_name', 'time_zone', 'country', 'team_name'])

export function getCategoryColumnName(category: DivisionCategoryRow): string {
  if (category.type !== DivisionCategoryType.CUSTOM) {
    return category.type.toLowerCase() + '_name'
  }

  const customName = category.customName
  if (!customName || !customName.trim()) {
    return 'custom_name'
  }

  const normalized = customName
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .replace(/\s+/g, '_')

  if (!normalized) {
    return 'custom_name'
  }

  return normalized + '_name'
}

export function getCategoryColumns(
  categories: DivisionCategoryRow[],
): { columnName: string; category: DivisionCategoryRow }[] {
  const usedNames = new Set<string>(RESERVED_COLUMNS)
  const result: { columnName: string; category: DivisionCategoryRow }[] = []

  for (const cat of categories) {
    let name = getCategoryColumnName(cat)

    if (usedNames.has(name)) {
      let suffix = 2
      while (usedNames.has(name + '_' + suffix)) {
        suffix++
      }
      name = name + '_' + suffix
    }

    usedNames.add(name)
    result.push({ columnName: name, category: cat })
  }

  return result
}
